import React from "react";
import { useNavigate } from "react-router-dom";
import "./Home.css"; // local overrides and new content styling

const Home = () => {
  const navigate = useNavigate();

  return (
    <div className="home-container">
      {/* Banner/Header */}
      <header className="banner">
        <div className="title-container">
          <h1 className="drop-in drop-in-1">DISCOVER</h1>
          <h1 className="drop-in drop-in-2">HIDDEN</h1>
          <h1 className="drop-in drop-in-3">INSIGHTS</h1>
          <button className="logout-btn" onClick={() => navigate("/about")}>
            Learn More
          </button>
        </div>
      </header>

      {/* Main content container */}
      <div className="main-content-home">
        {/* Hero Section */}
        <section className="hero">
          <div className="hero-content">
            <h2 className="hero-title">
              Collect Anonymous Feedback with Ease
            </h2>
            <p className="hero-subtitle">
              Create custom feedback groups, share a secure link, and let your team or
              customers respond anonymously. Our AI-powered analysis transforms raw
              feedback into actionable insights—so you can focus on what to improve.
            </p>
          </div>
        </section>

        {/* Features Section */}
        <section className="features">
          <div className="feature">
            <h3>Effortless Group Creation</h3>
            <p>
              Set up your feedback groups in seconds. Add a title, topic, and generate a link
              to invite participants—no complex setup required.
            </p>
          </div>
          <div className="feature">
            <h3>Anonymous & Secure</h3>
            <p>
              Respondents remain anonymous, encouraging honest and candid input. No sign-up
              needed for participants—just click and respond.
            </p>
          </div>
          <div className="feature">
            <h3>AI-Powered Analysis</h3>
            <p>
              Once responses are in, close the session and request an AI analysis for
              targeted bullet-point summaries of your team’s feedback.
            </p>
          </div>
        </section>

        {/* About Section */}
        <section className="about">
          <h2>About Anonysis</h2>
          <p>
            Anonysis.io is your trusted partner in feedback analysis. We combine simplicity,
            anonymity, and AI to help you harness the power of your people.
          </p>
        </section>

        {/* Call-to-Action Section */}
        <section className="call-to-action">
          <h2>Ready to Elevate Your Decision-Making?</h2>
          <br />
          <button className="logout-btn" onClick={() => navigate("/register")}>
            Sign Up Today
          </button>
        </section>
      </div>
    </div>
  );
};

export default Home;
